module.exports = __webpack_public_path__ + "static/joey-ff3609064809095adaea61d4fb68f892.jpg";